import styled from 'styled-components';

import { ThemeProp } from '../../../../../../theme/Themes';

export const AppMainContentContainer = styled.div`
  width: 100%;
  height: 100%;
  background: ${({ theme }: ThemeProp) => theme.colors.primary.c900};
  padding: 1.5rem 1rem;
`;
